export default __webpack_public_path__ + "images/information.v-580afeb223f84a6e79f807802a7eb857.svg";